import axios from './axios';

const URL = `${process.env.REACT_APP_PORTAL_URL}/api/v1/sessions/videos`;

export type SignedPart = {
  partNumber: number;
  url: string;
};

export type VideoUpload = {
  key: string;
  uploadId: string;
  gcsUrl: string;
  partSize: number;
  partCount: number;
  expiresAt: string;
  parts: SignedPart[];
};

export type UploadedPart = {
  partNumber: number;
  eTag: string;
};

export type UploadedVideo = {
  id: number;
  url: string;
  sortOrder: number;
};

export type CreateUploadRequest = {
  sessionId: number;
  filename: string;
  size: number;
  contentType: string;
};

export type CreateUploadedVideoRequest = {
  sessionId: number;
  sortOrder: number;
  key: string;
  uploadId: string;
  size: number;
  parts: UploadedPart[];
};

export type UploadApi = {
  create: (request: CreateUploadRequest) => Promise<VideoUpload>;
  createVideo: (request: CreateUploadedVideoRequest) => Promise<UploadedVideo>;
};

const videoUploads: UploadApi = {
  create: (request) => axios.get(`${URL}/upload`, { params: request }),
  createVideo: (request) => axios.post(URL, request),
};

export default videoUploads;
